module.exports = __webpack_public_path__ + "static/img/mCjgyBan@2x.69a64e94.png";